<template>
  <v-row style="align-items:center;">
      <div class="optionsXs">
        <v-btn icon class="btn-all-left" @click="$emit('changeDMenu')">
          <v-icon>fa-bars</v-icon>
        </v-btn>
      </div>
      <div class="divOptLg">
      <v-icon small>fa far fa-user</v-icon>
        <v-btn icon @click="submit" style="margin-left: 20px; width: auto;">        
        <span style="color:#fff;">{{ $t('top-menu.registration.menu_profile') }}</span>
      </v-btn>
    </div>
      <v-col md="8" sm="8" cols="7" class="optionsLg">
        <div class="styleMenuv" v-for="(option, index) in options" v-bind:key="index">
          <v-icon small>fa far fa-address-card</v-icon>
        <v-menu offset-y>
            <template v-slot:activator="{ on, attrs }">
                <v-btn dark icon v-bind="attrs" v-on="on" style="margin-left: 55px;">
                  <span style="color:#fff;">{{ $t('top-menu.registration.menu_registration') }}</span>
                    <v-icon small style="margin-top: -8px;">fa far fa-sort-down</v-icon>
                </v-btn>
            </template>
            <v-list v-if="option.items.length > 0">
            <v-list-item
                v-for="(item, index) in option.items"
                v-bind:key="index"
                :href="item.href"
            >
                <v-list-item-icon>
                    <v-icon small>{{ item.icon }}</v-icon>
                </v-list-item-icon>
                <v-list-item-title>{{ $tc(item.lang) }}</v-list-item-title>
                
            </v-list-item>
            </v-list>
        </v-menu>
        </div>
    </v-col>
      <v-col md="2" sm="2" cols="1" class="optionsLogout">
        <Logout class="logout_" :oldSystem="true"/>
    </v-col>
  </v-row>
</template>

<script>
import Logout from "@/components/layouts/Logout";
import { VRow, VCol, VMenu, VList, VListItem, VIcon, VBtn } from 'vuetify/lib';
export default {
    components:{
         Logout, VRow, VCol, VMenu, VList, VListItem, VIcon, VBtn
    },
  data() {
    return {
        host: null,
        options: [ {
          items: [
            {
              lang: "top-menu.registration.sm_reg_for_event",
              href: this.$store.getters.env.get('VUE_APP_DEV_API_HOST')+'/admin/selectRegistration',
              icon: "fa far fa-address-card"
            },
            {
              lang: "top-menu.registration.sm_regs_payments",
              href: this.$store.getters.env.get('VUE_APP_DEV_API_HOST')+'/admin/viewRegistrations',
              icon: "fa far fa-address-card"
            },
            {
              lang: "top-menu.registration.sm_msg_ur_promoter",
              href: this.$store.getters.env.get('VUE_APP_DEV_API_HOST')+'/admin/viewRegistrations',
              icon: "fa far fa-bullhorn"
            },
            {
              lang: "top-menu.registration.sm_join_org",
              href: this.$store.getters.env.get('VUE_APP_DEV_API_HOST')+'/organizations',
              icon: "fa far fa-user-plus"
            },
            {
              lang: "top-menu.registration.sm_ur_memberships",
              href: this.$store.getters.env.get('VUE_APP_DEV_API_HOST')+'/admin/viewMemberships',
              icon: "fa fas fa-users"
            },
            {
              lang: "top-menu.registration.sm_payments",
              href: this.$store.getters.env.get('VUE_APP_DEV_API_HOST')+'/admin/paymentList',
              icon: "fa far fa-credit-card"
            },
            {
              lang: "top-menu.registration.sm_unPaidRegistration",
              href: this.$store.getters.env.get('VUE_APP_BASE')+'unPaidRegistration',
              icon: "fa far fa-credit-card"
            },
          ],
        }
      ],
      dMenu: false
    };
  },
  methods: {
    submit() {

      window.location.href = this.$store.getters.env.get('VUE_APP_DEV_API_HOST')+'/admin/participantDashboard';
          
    }
  },
  created: function() {
    this.host = this.$store.getters.env.get('VUE_APP_DEV_API_HOST');
    this.$emit("loadOptionsRegistration", this.options)
  }
};
</script>
<style>
/*0{
  margin-left: 50%;
}
@media (max-width: 1024px) {
  .logout_{ margin-left: -15px !important;}
}*/
.optionsLg {
  max-width: calc(100% - 248px);
}
.optionsXs {
  padding: 12px; 
  display: none;
}
.divOptLg {
  padding: 12px;
}
.optionsLogout {
  min-width: 120px; 
  max-width: 120px;
}
@media (max-width: 768px) {
  .optionsLg, .divOptLg {
    display: none;
  }
  .optionsXs {
    display: block;
  }
  .optionsLogout {
    margin-left: auto;
  }
}
@media (max-width: 699px){
  .optionsLogout {
    min-width: 60px;
  }
}
@media (max-width: 406px) {
  .optionsXs {
    margin-left: 20px;
  }
}
.legacy-dashboard {
    text-align: right !important;
    text-align: -moz-right !important;
    text-decoration: underline !important;
    color: #0e152d !important;
    margin-right: 10px;
}
</style>

<style scoped>
.styleMenuv {
    display: contents;
}
a {
    color: #fff;
    text-decoration: none;
}
</style>